// Mock data for verification page

// Data passed as props to the root component
export const mockRootProps = {
  onVerify: async (pin: string): Promise<void> => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // Simulate validation
    if (pin === '12345678') {
      console.log('Verification successful!');
      // In real app, this would redirect to next step
    } else {
      throw new Error('Invalid PIN. Please try again.');
    }
  },
  isSubmitting: false,
  errorMessage: undefined
};

// No dynamic data required - all content is static text and form inputs